import { render } from "./BackerCenterGiftCardRow.vue?vue&type=template&id=0f2c992e"
import script from "./BackerCenterGiftCardRow.vue?vue&type=script&lang=js"
export * from "./BackerCenterGiftCardRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__